import type { DiagnosisItem } from "../types/landing";
export const diagnosisItems: DiagnosisItem[] = [
  {
    id: "empezar",
    label: "No sé por dónde empezar.",
    reference: "Tomo 1 · Japonés desde cero",
    response: "Arrancás por hiragana y katakana, y cada tomo indica la etapa que estás trabajando.",
  },
  {
    id: "videos",
    label: "Guardo videos, pero no sigo una secuencia.",
    reference: "Recorrido de 7 tomos",
    response: "Los tomos siguen un orden: cuando terminás uno, sabés cuál viene después.",
  },
  {
    id: "escritura",
    label: "Me cuesta organizar los sistemas de escritura.",
    reference: "Tomo 1 · Bonos de kanji en Pro y Completo",
    response: "El Tomo 1 ordena hiragana y katakana. Los bonos de kanji suman práctica específica de caracteres.",
  },
  {
    id: "practicar",
    label: "Leo explicaciones, pero necesito practicar.",
    reference: "Tomo 3 · Tomo 7",
    response: "Bases del N5 combina explicación, ejemplos y ejercicios. Integración N4 suma ejercicios y autoevaluación.",
  },
  {
    id: "palabras",
    label: "Busco palabras en muchos lugares distintos.",
    reference: "Diccionario de 5.000 palabras · Plan Completo",
    response: "Tenés un solo lugar para consultar vocabulario mientras estudiás.",
  },
  {
    id: "situaciones",
    label: "Quiero usar lo que aprendo en situaciones reales.",
    reference: "Tomo 6 · Japonés para viajes en Completo",
    response: "Japonés en contexto trabaja situaciones cotidianas. La guía de viajes organiza expresiones por situación.",
  },
];
export const audiences = [
  {
    title: "Quienes empiezan desde cero",
    text: "No necesitás conocimientos previos: el primer tomo arranca por la escritura y las expresiones iniciales.",
  },
  {
    title: "Quienes retoman después de abandonar",
    text: "Identificás en qué etapa quedaste y retomás desde el tomo que corresponde, sin empezar todo de nuevo.",
  },
  {
    title: "Quienes estudian por su cuenta",
    text: "El material está ordenado para que sepas qué estudiar hoy y qué sigue mañana, a tu ritmo.",
  },
  {
    title: "Quienes buscan una base organizada antes de viajar",
    text: "Estudiás lo esencial con orden y, si elegís el Completo, sumás expresiones agrupadas por situación de viaje.",
  },
];
export const systemSteps = [
  {
    title: "Elegí el tomo que corresponde a tu etapa.",
    text: "Si empezás de cero, vas al Tomo 1. Si ya conocés los silabarios, podés ubicarte en el tomo siguiente.",
  },
  {
    title: "Estudiá el tema y trabajá sus ejemplos.",
    text: "Las explicaciones en español van acompañadas de ejemplos para ver cómo se usa cada estructura.",
  },
  {
    title: "Practicá y retomá lo que necesites reforzar.",
    text: "Si en Rumbo al N4 una estructura básica te hace dudar, sabés que conviene volver a Bases del N5.",
  },
];
export const comparisonRows = [
  { scattered: "Elegís recursos sin una secuencia.", organized: "Seguís un recorrido por tomos." },
  { scattered: "Saltás entre temas sin saber en qué nivel estás.", organized: "Identificás la etapa que estás trabajando." },
  { scattered: "Leés explicaciones sin aplicarlas.", organized: "Combinás explicación y práctica." },
  { scattered: "Buscás dónde estaba ese tema que viste una vez.", organized: "Volvés al tomo correspondiente." },
];
export const completoAdvantages = [
  { title: "Frente al Base", text: "Agrega los cinco bonos de kanji y los dos recursos de aplicación y consulta." },
  { title: "Frente al Pro", text: "Suma Japonés práctico para viajes y el diccionario de 5.000 palabras." },
  { title: "Durante el estudio", text: "Te permite ampliar la consulta de vocabulario sin salir del material." },
  { title: "Al preparar un viaje", text: "Organiza expresiones por situación: transporte, alojamiento, comidas, compras y pedidos de ayuda." },
];
export const deliverySteps = [
  { title: "Elegís el plan", text: "Base, Pro o Completo, según cómo quieras estudiar." },
  { title: "Completás la compra", text: "Desde el botón del plan elegido." },
  { title: "Accedés a tus archivos", text: "Recibís los ebooks en PDF incluidos en tu opción." },
];
